import { render, staticRenderFns } from "./otpCountReport.vue?vue&type=template&id=2e1a3edc&scoped=true&"
import script from "./otpCountReport.vue?vue&type=script&lang=js&"
export * from "./otpCountReport.vue?vue&type=script&lang=js&"
import style0 from "./otpCountReport.vue?vue&type=style&index=0&id=2e1a3edc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a3edc",
  null
  
)

export default component.exports